<div class="flex justify-between">
  <div class="flex w-9/12 gap-x-2">
    <tui-input
      class="w-4/12 contrast-disabled-field"
      tuiTextfieldSize="m"
      [formControl]="computedProperties.controls.totalWarmPlaces"
      >Тепло</tui-input
    >
    <tui-input
      class="w-4/12 contrast-disabled-field"
      tuiTextfieldSize="m"
      [formControl]="computedProperties.controls.totalColdPlaces"
      >Холод</tui-input
    >
    <tui-input-number
      class="w-1/12 contrast-disabled-field"
      tuiTextfieldSize="m"
      [formControl]="computedProperties.controls.totalBox"
      >Коробки</tui-input-number
    >
    <tui-input-number
      tuiTextfieldSize="m"
      class="w-1/12 contrast-disabled-field"
      [formControl]="vehicleLoadingPercent"
      >Загрузка %</tui-input-number
    >
  </div>
  <div
    class="flex gap-x-2 w-3/12"
    #card="tuiActiveZone"
    (tuiActiveZoneChange)="zoneChanged$.next($event)"
  >
    <tui-input
      [formControl]="form.controls.temperatureRegime"
      tuiTextfieldSize="m"
      class="contrast-disabled-field w-1/2"
      >Температурный режим</tui-input
    >
    <tui-input-number
      tuiTextfieldSize="m"
      class="contrast-disabled-field w-1/2"
      [precision]="2"
      [formControl]="form.controls.grossWeight"
      >Вес брутто по весам</tui-input-number
    >
  </div>
</div>
